import axios from 'axios';

const defaultURL = 'https://192.168.1.10:8205';
const storageKey = 'cdrfiles_server_url';

// --- 1. Сначала объявляем функции как обычные функции/константы

export const GetCdrfilesServerURL = () => {
  let url = localStorage.getItem(storageKey);
  if (!url) {
    SetCdrfilesServerURL(defaultURL);
    url = defaultURL;
  }
  return url;
};

export const SetCdrfilesServerURL = (url) => {
  if (url) {
    localStorage.setItem(storageKey, url);
  }
};

export const getCdrfilePreview = (imageId) => {
  return GetCdrfilesServerURL() + `/pngfiles/${imageId}.png`;
};

export const getHealthUrl = () => {
  return GetCdrfilesServerURL() + `/health`;
};

// --- 2. Теперь создаём axios-инстанс. К моменту вызова GetCdrfilesServerURL
// функции уже определены.

const cdrFilesService = axios.create({
  baseURL: GetCdrfilesServerURL() + '/api',
});

// --- 3. Навешиваем на инстанс методы (для обратной совместимости с текущим кодом)

cdrFilesService.GetCdrfilesServerURL = GetCdrfilesServerURL;
cdrFilesService.SetCdrfilesServerURL = SetCdrfilesServerURL;
cdrFilesService.getCdrfilePreview = getCdrfilePreview;
cdrFilesService.getHealthUrl = getHealthUrl;

cdrFilesService.health = async () => {
  return await cdrFilesService.get(getHealthUrl());
};

// Interceptor для добавления токена в заголовки
cdrFilesService.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Interceptor для отлова 401 ошибки
cdrFilesService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default cdrFilesService;